// export const srArtContext = '/srArt/newsInfo'

export default [
  {
    path: `/exchange`,
    name: '学术交流',
    meta: {
      title: '学术交流-上饶美术馆',
    },
    component: () => import('../views/exchange/exchange.vue'),
  },
  {
    path: `/study`,
    name: '学术研究',
    meta: {
      title: '学术研究-上饶美术馆',
    },
    component: () => import('../views/exchange/exchange.vue'),
  },
  {
    path: `/exchangeDetail`,
    name: '学术研究详请',
    meta: {
      title: '学术研究详请-上饶美术馆',
    },
    component: () => import('../views/exchange/exchangenews.vue'),
  },
  {
    path: `/activities`,
    name: '学术活动',
    meta: {
      title: '学术活动-上饶美术馆',
    },
    component: () => import('../views/exchange/activities.vue'),
  },
  {
    path: `/activitiesDetail`,
    name: '学术活动详请',
    meta: {
      title: '学术活动详请-上饶美术馆',
    },
    component: () => import('../views/exchange/activitiesnews.vue'),
  }
]

